module.exports = __webpack_public_path__ + "img/应急处理.82d0dcbc.png";